var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "div",
        { staticClass: "header-caption" },
        [
          _c(
            "el-row",
            { staticClass: "mb10" },
            [
              _c(
                "el-col",
                { attrs: { span: 21 } },
                [
                  _c(
                    "el-breadcrumb",
                    { attrs: { "separator-class": "el-icon-arrow-right" } },
                    _vm._l(_vm.breadcrumbArray, function (item, index) {
                      return _c(
                        "el-breadcrumb-item",
                        {
                          key: index,
                          nativeOn: {
                            click: function ($event) {
                              return _vm.getBreadcrumb(item.pid, index)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-col", { staticClass: "text-right", attrs: { span: 3 } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("file.total")) +
                      " " +
                      _vm._s(_vm.total) +
                      " " +
                      _vm._s(_vm.$t("file.individual"))
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.fileData.length > 0
        ? _c("div", [
            _c("div", { staticClass: "first-header" }, [
              _c(
                "p",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.fileData.length <= 0, label: 0 },
                      on: {
                        change: function ($event) {
                          return _vm.checkChange(1)
                        },
                      },
                      model: {
                        value: _vm.menuIds,
                        callback: function ($$v) {
                          _vm.menuIds = $$v
                        },
                        expression: "menuIds",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.checked
                              ? _vm.$t("file.reverse")
                              : _vm.$t("file.all")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              (_vm.fileStyle.style == 1 ? true : false)
                ? _c("p", [_vm._v(_vm._s(_vm.$t("file.updatetime")))])
                : _vm._e(),
              _vm._v(" "),
              (_vm.fileStyle.style == 1 ? true : false)
                ? _c("p", [_vm._v(_vm._s(_vm.$t("file.collection")))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "public-ul",
                class: _vm.fileStyle.style == 1 ? "content-ul" : "infeed-ul",
              },
              _vm._l(_vm.fileData, function (item, index) {
                return _c("li", { key: index }, [
                  _c(
                    "div",
                    { staticClass: "content-left pointer" },
                    [
                      _c("el-checkbox", {
                        key: item.id,
                        attrs: { label: item.id },
                        on: {
                          change: function ($event) {
                            return _vm.checkChange(2)
                          },
                        },
                        model: {
                          value: _vm.menuIds,
                          callback: function ($$v) {
                            _vm.menuIds = $$v
                          },
                          expression: "menuIds",
                        },
                      }),
                      _vm._v(" "),
                      _vm.renameIndex !== index
                        ? _c(
                            "p",
                            {
                              staticClass: "public-title",
                              on: {
                                click: function ($event) {
                                  return _vm.getItemFile(item)
                                },
                                contextmenu: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.rightClick($event, item, index)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon iconfont",
                                class: _vm.getFileType(
                                  item.type,
                                  item.file_url
                                ),
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "over-text" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                            ]
                          )
                        : _c("p", { staticClass: "public-title" }, [
                            _c("i", {
                              staticClass: "icon iconfont",
                              class: _vm.getFileType(item.type, item.file_url),
                              on: {
                                click: function ($event) {
                                  return _vm.getItemFile(item)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.name,
                                  expression: "item.name",
                                },
                              ],
                              staticClass: "rename-input",
                              attrs: {
                                id: "input" + index,
                                placeholder: _vm.$t("file.placeholder10"),
                                autofocus: "autofocus",
                                maxlength: "20",
                              },
                              domProps: { value: item.name },
                              on: {
                                blur: function ($event) {
                                  return _vm.renameBlur(item)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(item, "name", $event.target.value)
                                },
                              },
                            }),
                          ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  (_vm.fileStyle.style == 1 ? true : false)
                    ? _c("div", [_vm._v(_vm._s(item.updated_at))])
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.fileStyle.style === 1 ? true : false)
                    ? _c("div", { staticClass: "icon-star" }, [
                        _c("i", {
                          staticClass: "collect",
                          class:
                            item.is_collect === 0
                              ? "el-icon-star-off"
                              : "el-icon-star-on color-collect",
                          on: {
                            click: function ($event) {
                              return _vm.getCollect(item)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "icon-star-right" },
                          [
                            item.type !== 1 && _vm.fileIsImage(item.file_type)
                              ? _c("i", {
                                  staticClass: "icon iconfont iconfenxiang",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setShare(item, 2)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-popover",
                              {
                                ref: "pop-" + index,
                                refInFor: true,
                                attrs: {
                                  offset: 30,
                                  width: 40,
                                  placement: "bottom-start",
                                  "popper-class": "area_popper",
                                  trigger: "click",
                                },
                                on: {
                                  "after-enter": function ($event) {
                                    return _vm.handleShow(index)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "right-item-list" }, [
                                  item.type == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "right-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.setShortcutItem(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                item.is_shortcut === 0
                                                  ? _vm.$t("file.setcommon")
                                                  : _vm.$t("file.cancelcommon")
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.type != 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "right-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.fileDownLoad(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("public.download")
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.type != 1 &&
                                  _vm.fileIsImage(item.file_type)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "right-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.setShare(item, 1)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                item.is_share === 0
                                                  ? _vm.$t("file.share")
                                                  : _vm.$t("file.cancelsharing")
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "right-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.getStartCollect(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            item.is_collect === 0
                                              ? _vm.$t("file.collection")
                                              : _vm.$t("file.cancelcollection")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "right-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.getMoveDialog(item, 1)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("file.moveto")))]
                                  ),
                                  _vm._v(" "),
                                  item.type !== 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "right-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.getMoveDialog(item, 2)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("file.copyto")) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "right-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.setRenameItem(item, index)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("file.rename")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "right-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.getFileAttribute(item)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("file.attribute")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "right-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.getFolderDelete(item.id)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("public.delete")))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "icon iconfont icongengduo1",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.where.page,
                    "page-size": _vm.where.limit,
                    "page-sizes": [10, 15, 20],
                    total: _vm.total,
                    layout: "total, prev, pager, next, jumper",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.pageChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _c("default-page", { attrs: { index: 7, "min-height": 510 } }),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("share-dialog", {
        ref: "shareDialog",
        attrs: { "from-data": _vm.fromData },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("move-dialog", {
        ref: "moveDialog",
        attrs: { "move-data": _vm.moveData },
        on: { handlerMove: _vm.handlerMove },
      }),
      _vm._v(" "),
      _c("file-attribute", {
        ref: "fileAttribute",
        attrs: { "form-data": _vm.formBoxConfig },
      }),
      _vm._v(" "),
      _c("right-click", {
        ref: "rightClick",
        attrs: { "config-data": _vm.rightData },
        on: { handleRightClick: _vm.handleRightClick },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }